<script setup>
const commercialStore = useCommercialStore()
const app_config = useAppConfig()
const { header, seo_mode, objBreadcrumb } = defineProps({
    header: {
        type: String,
        default: 'Каталог недвижимости'
    },
    seo_mode: {
        type: Boolean,
        default: false
    },
    active_tab: {
        type: String,
        default: 'list'
    },
    objBreadcrumb: {
        type: Object,
        default: ''
    },
})
commercialStore.seo_mode = seo_mode
const activeTab = ref('list')
// console.log('objBreadcrumb', objBreadcrumb);

function capitalizeFirstLetter(string) { 
    if (!string) return string; // Проверка на пустую строку 
    return string.charAt(0).toUpperCase() + string.slice(1); 
}

let itemsBreadcrumb = ref([])
if(objBreadcrumb.subtype_data){
    itemsBreadcrumb.value = [
        { label: app_config.city.im, to: "/" },
        { label: capitalizeFirstLetter(objBreadcrumb.offerType.header), to: "/" + objBreadcrumb.offerType.slug + "/" },
        { label: capitalizeFirstLetter(objBreadcrumb.data_type.label), to: "/" + objBreadcrumb.offerType.slug + "/" + objBreadcrumb.data_type.slug + "/" },
        { label: objBreadcrumb.subtype_data.header, to: null },
    ];
}
if(objBreadcrumb.data_type && !objBreadcrumb.subtype_data){
    itemsBreadcrumb.value = [
        { label: app_config.city.im, to: "/" },
        { label: capitalizeFirstLetter(objBreadcrumb.offerType.header), to: "/" + objBreadcrumb.offerType.slug + "/" },
        { label: capitalizeFirstLetter(objBreadcrumb.data_type.label), to: null},
    ];
}
if(objBreadcrumb.offerType && !objBreadcrumb.data_type && !objBreadcrumb.subtype_data){
    itemsBreadcrumb.value = [
        { label: app_config.city.im, to: "/" },
        { label: capitalizeFirstLetter(objBreadcrumb.offerType.header), to: null },
    ];
}
if(objBreadcrumb.catalog && objBreadcrumb.catalog.subtitle){
    itemsBreadcrumb.value = [
        { label: app_config.city.im, to: "/" },
        { label: objBreadcrumb.catalog.title, to: "/" + objBreadcrumb.catalog.link + "/" },
        { label: objBreadcrumb.catalog.subtitle, to: null},
    ];
}
if(objBreadcrumb.catalog && !objBreadcrumb.catalog.subtitle){
    itemsBreadcrumb.value = [
        { label: app_config.city.im, to: "/" },
        { label: objBreadcrumb.catalog.title, to: null},
    ];
}
if(objBreadcrumb.raion){
    itemsBreadcrumb.value = [
        { label: app_config.city.im, to: "/" },
        { label: capitalizeFirstLetter(objBreadcrumb.offerType.header), to: "/" + objBreadcrumb.offerType.slug + "/" },
        { label: capitalizeFirstLetter(objBreadcrumb.data_type.label), to: "/" + objBreadcrumb.offerType.slug + "/" + objBreadcrumb.data_type.slug + "/" },
        { label: objBreadcrumb.raion.header + " район", to: null },
    ];
}
if(objBreadcrumb.metro){
    itemsBreadcrumb.value = [
        { label: app_config.city.im, to: "/" },
        { label: capitalizeFirstLetter(objBreadcrumb.offerType.header), to: "/" + objBreadcrumb.offerType.slug + "/" },
        { label: capitalizeFirstLetter(objBreadcrumb.data_type.label), to: "/" + objBreadcrumb.offerType.slug + "/" + objBreadcrumb.data_type.slug + "/" },
        { label: "метро " + objBreadcrumb.metro.header, to: null },
    ];
}

</script>
<template>

    <section data-offer class="relative md:py-6">
        <div
            class="md:block hidden absolute inset-0 bg-[url('public/img/main-bg.png')] bg-no-repeat bg-cover bg-center bg-gray-600 bg-opacity-50 z-0">
        </div>
        <div
            class="md:block hidden absolute top-[3px] bottom-[0px] left-0 right-0 bg-[url('public/img/main-bg.png')] bg-no-repeat bg-cover bg-center bg-gray-600 bg-opacity-50 z-[5] filter blur-[3px]">
        </div>
        <div class="container">
            <layouts-breadcrumbs :items="itemsBreadcrumb" />
            <h3 class="relative z-10 text-white pb-6 hidden md:block text-xl lg:font-normal uppercase pt-4">
                {{ header }}
            </h3>
            <div class="relative z-20">
                <slot name="filter"></slot>
            </div>
        </div>
    </section>

    <section data-tool class="stats bg-brand-bright pt-2">
        <div class="container flex items-center justify-between py-4">

            <h3 data-total class="text-[13px] md:text-xl text-brand-grey">
                <span class="text-inherit hidden md:inline">НАЙДЕНО </span>
                <span>
                    {{ commercialStore.count }}
                    {{ godgodalet(commercialStore.count, ['ОБЪЕКТ', 'ОБЪЕКТА', 'ОБЪЕКТОВ']) }}
                </span>
            </h3>

            <div class="items-center py-3 md:py-0 w-full md:w-auto hidden md:flex">
                <div @click="commercialStore.applyOfferType('arenda')" :class="commercialStore.filter.offer === 'arenda' ? 'bg-[#53B3F8] text-white' : 'bg-white text-black'"
                    class="cursor-pointer p-1.5 px-4 rounded-l-md w-full text-center md:w-auto">
                    <p class="text-sm md:text-base font-normal">Аренда</p>
                </div>
                <div @click="commercialStore.applyOfferType('prodaja')" :class="commercialStore.filter.offer === 'prodaja' ? 'bg-[#00c37e] text-white' : 'bg-white text-black'"
                    class="cursor-pointer p-1.5 px-4 rounded-r-md w-full text-center md:w-auto">
                    <p class="text-sm md:text-base font-normal">Продажа</p>
                </div>
            </div>

            <div data-toggle="pc_list-list_map-map" class="items-center py-3 md:py-0 w-full md:w-auto hidden md:flex">
                <div @click="commercialStore.view = 'list'"
                    :class="commercialStore.view === 'list' ? 'bg-[#53B3F8] text-white' : 'bg-white text-black'"
                    class="cursor-pointer p-1.5 px-4 rounded-l-md w-full text-center md:w-auto">
                    <p class="text-sm md:text-base font-normal">Карточки</p>
                </div>
                <div @click="commercialStore.view = 'list_map'"
                    :class="commercialStore.view === 'list_map' ? 'bg-[#53B3F8] text-white' : 'bg-white text-black'"
                    class="cursor-pointer p-1.5 px-4 w-full text-center md:w-auto">
                    <p class="text-sm md:text-base font-normal">Карточки+Карта</p>
                </div>
                <div @click="commercialStore.view = 'map'"
                    :class="commercialStore.view === 'map' ? 'bg-[#53B3F8] text-white' : 'bg-white text-black'"
                    class="cursor-pointer p-1.5 px-4 rounded-r-md w-full text-center md:w-auto">
                    <p class="text-sm md:text-base font-normal">Карта</p>
                </div>
            </div>

            <div data-toggle="mob_list-map" class="flex items-center gap-2">
                <div :class="commercialStore.view === 'map' && '!hidden md:!block'">
                    <UiSelectSort v-model="commercialStore.filter.sort" :items="commercialStore.sorts"
                        @onUpdate="commercialStore.applyFilter(true)" />
                </div>
                <div @click.prevent="commercialStore.view === 'map' ? commercialStore.view = 'list' : commercialStore.view = 'map'"
                    class="bg-white p-[9px] rounded-lg block md:hidden">
                    <svg v-if="commercialStore.view === 'list'" width="16" height="18" viewBox="0 0 16 18" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M13.6566 2.31627C15.1253 3.76798 15.9653 5.72745 15.9989 7.78033C16.0326 9.83321 15.2573 11.8186 13.837 13.3166L13.6566 13.5011L9.88513 17.2285C9.40658 17.7013 8.76415 17.9765 8.08797 17.9986C7.4118 18.0206 6.75243 17.7877 6.24344 17.3471L6.11545 17.2285L2.3431 13.5002C0.842838 12.0171 0 10.0056 0 7.90825C0 5.81085 0.842838 3.79936 2.3431 2.31627C3.84336 0.833188 5.87815 0 7.99984 0C10.1215 0 12.1563 0.833188 13.6566 2.31627ZM7.99984 5.27218C7.64966 5.27218 7.3029 5.34037 6.97938 5.47284C6.65585 5.60532 6.36189 5.79949 6.11427 6.04427C5.86665 6.28905 5.67023 6.57965 5.53623 6.89947C5.40222 7.21929 5.33324 7.56208 5.33324 7.90825C5.33324 8.25442 5.40222 8.59721 5.53623 8.91703C5.67023 9.23685 5.86665 9.52745 6.11427 9.77223C6.36189 10.017 6.65585 10.2112 6.97938 10.3437C7.3029 10.4761 7.64966 10.5443 7.99984 10.5443C8.70707 10.5443 9.38533 10.2666 9.88541 9.77223C10.3855 9.27787 10.6664 8.60738 10.6664 7.90825C10.6664 7.20912 10.3855 6.53863 9.88541 6.04427C9.38533 5.54991 8.70707 5.27218 7.99984 5.27218Z"
                            fill="#53B3F8" />
                    </svg>
                    <svg v-if="commercialStore.view === 'map'" width="18" height="15" viewBox="0 0 18 15" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M7.13189 0H1.08162C0.814182 0 0.557697 0.0888949 0.368589 0.247129C0.179482 0.405363 0.0732422 0.619974 0.0732422 0.843751V5.90626C0.0732422 6.13003 0.179482 6.34465 0.368589 6.50288C0.557697 6.66111 0.814182 6.75001 1.08162 6.75001H7.13189C7.39933 6.75001 7.65582 6.66111 7.84492 6.50288C8.03403 6.34465 8.14027 6.13003 8.14027 5.90626V0.843751C8.14027 0.619974 8.03403 0.405363 7.84492 0.247129C7.65582 0.0888949 7.39933 0 7.13189 0Z"
                            fill="#53B3F8" />
                        <path
                            d="M16.9918 0H10.9415C10.674 0 10.4176 0.0888949 10.2285 0.247129C10.0393 0.405363 9.93311 0.619974 9.93311 0.843751V5.90626C9.93311 6.13003 10.0393 6.34465 10.2285 6.50288C10.4176 6.66111 10.674 6.75001 10.9415 6.75001H16.9918C17.2592 6.75001 17.5157 6.66111 17.7048 6.50288C17.8939 6.34465 18.0001 6.13003 18.0001 5.90626V0.843751C18.0001 0.619974 17.8939 0.405363 17.7048 0.247129C17.5157 0.0888949 17.2592 0 16.9918 0Z"
                            fill="#53B3F8" />
                        <path
                            d="M7.13189 8.25H1.08162C0.814182 8.25 0.557697 8.3389 0.368589 8.49713C0.179482 8.65536 0.0732422 8.86997 0.0732422 9.09375V14.1563C0.0732422 14.38 0.179482 14.5946 0.368589 14.7529C0.557697 14.9111 0.814182 15 1.08162 15H7.13189C7.39933 15 7.65582 14.9111 7.84492 14.7529C8.03403 14.5946 8.14027 14.38 8.14027 14.1563V9.09375C8.14027 8.86997 8.03403 8.65536 7.84492 8.49713C7.65582 8.3389 7.39933 8.25 7.13189 8.25Z"
                            fill="#53B3F8" />
                        <path
                            d="M16.9918 8.25H10.9415C10.674 8.25 10.4176 8.3389 10.2285 8.49713C10.0393 8.65536 9.93311 8.86997 9.93311 9.09375V14.1563C9.93311 14.38 10.0393 14.5946 10.2285 14.7529C10.4176 14.9111 10.674 15 10.9415 15H16.9918C17.2592 15 17.5157 14.9111 17.7048 14.7529C17.8939 14.5946 18.0001 14.38 18.0001 14.1563V9.09375C18.0001 8.86997 17.8939 8.65536 17.7048 8.49713C17.5157 8.3389 17.2592 8.25 16.9918 8.25Z"
                            fill="#53B3F8" />
                    </svg>
                </div>
            </div>

        </div>
    </section>

    <section data-content class="result bg-brand-bright md:pb-4 md:pt-4 pt-0">
        <div class="container">

            <div data-view="list" v-if="commercialStore.view === 'list'">
                <div class="cards grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 items-center gap-2 md:gap-4 mb-4">
                    <LayoutsCard v-if="commercialStore.showList" v-for="item in commercialStore.items" :key="item.id"
                        :item="item" />
                </div>
                <div class="" v-if="commercialStore.items.length < parseInt(commercialStore.count)">
                    <div class="w-full flex justify-center items-center">
                        <button @click="commercialStore.paginator()"
                            class="w-full cursor-pointer border border-brand-blue rounded-md py-2 px-4 hover:bg-indigo-100">
                            <span class="text-brand-blue font-semibold font-Montserrat">Показать ещё</span>
                        </button>
                    </div>
                </div>
            </div>

            <div data-view="list_map" v-if="commercialStore.view === 'list_map'"
                class="flex items-stretch gap-8 flex-col lg:flex-row">
                <div class="max-h-[600px] lg:h-auto flex-1 overflow-auto">
                    <div class="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-2 ">
                        <LayoutsCard v-if="commercialStore.showList" v-for="item in commercialStore.items"
                            :key="item.id" :item="item" />
                    </div>
                    <div class="" v-if="commercialStore.items.length < commercialStore.count">
                        <div class="w-full flex justify-center items-center">
                            <button @click="commercialStore.paginator()"
                                class="w-full cursor-pointer border border-brand-blue rounded-md py-2 px-4 hover:bg-indigo-100">
                                <span class="text-brand-blue font-semibold font-Montserrat">Показать ещё</span>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="h-[600px] lg:h-auto flex-1">
                    <CatalogMap v-if="commercialStore.view === 'list_map'" width="100%" height="100%"
                        class="rounded-xl overflow-hidden" />
                </div>
            </div>

            <div data-view="map" v-if="commercialStore.view === 'map'" class="h-[600px]">
                <CatalogMap v-if="commercialStore.view === 'map'" width="100%" height="100%"
                    class="rounded-xl overflow-hidden" />
            </div>

        </div>
    </section>

    <slot name="end"></slot>

</template>